export enum EUserTags {
	BANNED = "BANNED",
	PROGRAM_DELETED = "PROGRAM_DELETED",
	DATA_COMPLETE = "DATA_COMPLETE",
	TWO_FACTOR_AUTH = "TWO_FACTOR_AUTH",
	EMAIL_VERIFIED = "EMAIL_VERIFIED",
	FREE_TRIAL_USED = "FREE_TRIAL_USED",
	FREE_PLAN_USED = "FREE_PLAN_USED"
}
